import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { assetActions } from "./actions";
import { AssetState } from "./types";

const initialState: AssetState = {
  showSms: null,
  maintenanceInfo: null,
};

export function AssetReducer(state = initialState, action: Action): AssetState {
  if (isType(action, assetActions.fetchSettings.done)) {
    return {
      ...state,
      showSms: action.payload.result.showSms,
    };
  }

  if (isType(action, assetActions.fetchMaintenance.done)) {
    return {
      ...state,
      maintenanceInfo: action.payload.result,
    };
  }

  if (isType(action, assetActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
